import { render } from "./PostCarpool.view.vue?vue&type=template&id=5cf5e7bc"
import script from "./PostCarpool.view.vue?vue&type=script&lang=js"
export * from "./PostCarpool.view.vue?vue&type=script&lang=js"

import "./PostCarpool.view.vue?vue&type=style&index=0&id=5cf5e7bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__